import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {OrderTypes} from "./Product";

export type DiscountType = "percentage" | "specified";

@usingJsonToModelConvertor
export default class Discount extends Model{

    @fromJsonObject({key: 'id'})
    public id!:number;

    @fromJsonObject({key: 'branch_id'})
    public branchId!:number;

    @fromJsonObject({key: 'product_id'})
    public productId!:number;

    @fromJsonObject({key: 'order_types_accepted', modelClass: String, isArray: true})
    public orderTypesAccepted!:OrderTypes[];

    @fromJsonObject({key: 'discount_type'})
    public discountType!:DiscountType;

    @fromJsonObject({key: 'discount'})
    public discount!:number;

    @fromJsonObject({key: 'group_id'})
    public groupId!:number;

    @fromJsonObject({key: 'is_expired'})
    public isExpired!:boolean;

    @fromJsonObject({key: 'status'})
    public status!:string;

    @fromJsonObject({key: 'title'})
    public title!:string;


}